import React, { useContext } from "react";

//styling
import "./clusterRow.css";

//global state
import { StateContext } from "../../AppStateContext";

//for formatting date
import moment from "moment";

//Material UI stuff
import TableCell from "@material-ui/core/TableCell";

const ClusterRowInfoExpires = ({ clusterInfo }) => {
  //consume global state
  const state = useContext(StateContext);

  return (
    <TableCell
      align="left"
      style={{
        borderBottom:
          state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      <p
        className={
          state.theme === "dark"
            ? "__tableCell __tableCellDark"
            : "__tableCell __tableCellLight"
        }
      >
        {moment(clusterInfo.data.status.endTime).format(
          "ddd, MM/DD/YY, h:mm a"
        )}
      </p>
    </TableCell>
  );
};

export default ClusterRowInfoExpires;
